import React from "react";
import premiumIngredientsImg from "../../../assets/Images/about/premium-ingredients.png";
import scienceDrivenImg from "../../../assets/Images/about/science-driven.png";
import innovativeSolutionsImg from "../../../assets/Images/about/innovative-solutions.png";
import safetyFirstImg from "../../../assets/Images/about/safety-first.png";
import transparentLabelingImg from "../../../assets/Images/about/transparent-labeling.png";
import exceptionalSupportImg from "../../../assets/Images/about/exceptional-support.png";
import bigLogoImg from "../../../assets/Images/about/big-logo.svg";

const Third_AboutUs_Section = () => {
  const brandGreen = "#355931";
  const bodyText = "#4b6659";
  const cardBg = "#FFFFFF";
  const pageBg = "#FFFFFF";
  const borderTint = "#E2E8DE";
  const softTint = "#F3F6F1";

  const leftCards = [
    {
      image: premiumIngredientsImg,
      title: "Advanced Manufacturing Facility",
      description:
        "Our plant uses advanced technology with GMP and ISO standards.",
      shift: "lg:ml-10",
    },
    {
      image: scienceDrivenImg,
      title: "On-Time Delivery",
      description:
        "We complete every order on time with reliable and efficient service.",
      shift: "lg:mr-16",
    },
    {
      image: innovativeSolutionsImg,
      title: "Customized Product Solutions",
      description:
        "We offer custom formulations, packaging, and labeling for every client.",
      shift: "lg:ml-10",
    },
  ];

  const rightCards = [
    {
      image: safetyFirstImg,
      title: "Transparent Processes",
      description:
        "We maintain complete transparency in ingredients, manufacturing, and labeling.",
      shift: "lg:mr-10",
    },
    {
      image: transparentLabelingImg,
      title: "After-Sales Support",
      description:
        "Our support team ensures seamless coordination even after order completion.",
      shift: "lg:ml-16",
    },
    {
      image: exceptionalSupportImg,
      title: "Pure and Safe Ingredients",
      description:
        "Every ingredient is carefully selected and verified to ensure purity and safety.",
      shift: "lg:mr-10",
    },
  ];

  const Card = ({ image, title, description, shift, side, index }) => (
    <div
      className={`${shift} group relative rounded-[14px] px-5 py-5 sm:px-7 sm:py-6 flex items-start gap-5
        border transition-all duration-500 ease-out
        hover:-translate-y-[3px] hover:shadow-[0_18px_40px_rgba(53,89,49,0.12)]
        shadow-[0_2px_10px_rgba(53,89,49,0.05)]`}
      style={{
        backgroundColor: cardBg,
        borderColor: borderTint,
      }}
    >
      {/* Top Accent Line */}
      <span
        className={`absolute top-0 h-[2px] transition-all duration-500
          ${side === "left" ? "left-6 right-10" : "left-10 right-6"}`}
        style={{ backgroundColor: brandGreen, opacity: 0.55 }}
        aria-hidden="true"
      />

      {/* Number */}
      <span
        className={`absolute top-3 text-[10px] tracking-[0.3em] font-semibold
          ${side === "left" ? "right-4" : "left-4"}`}
        style={{ color: brandGreen, opacity: 0.55 }}
        aria-hidden="true"
      >
        {String(index).padStart(2, "0")}
      </span>

      {/* Icon */}
      <div
        className="relative flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center
          transition-transform duration-500 group-hover:scale-[1.04]"
        style={{
          backgroundColor: softTint,
          boxShadow: "inset 0 0 0 1px rgba(53,89,49,0.25)",
        }}
      >
        <span
          className="absolute inset-0 rounded-full transition-opacity duration-500 opacity-0 group-hover:opacity-100"
          style={{ boxShadow: "0 0 0 4px rgba(53,89,49,0.10)" }}
          aria-hidden="true"
        />

        {image ? (
          <img
            src={image}
            alt={title}
            className="w-8 h-8 sm:w-9 sm:h-9 object-contain"
            loading="lazy"
          />
        ) : null}
      </div>

      {/* Text */}
      <div className="flex-1 min-w-0 pt-0.5">
        <h3
          className="text-[14px] sm:text-[15.5px] font-semibold tracking-[0.02em] leading-snug"
          style={{ color: brandGreen }}
        >
          {title}
        </h3>

        <span
          className="block mt-2 mb-2 h-px w-8"
          style={{ backgroundColor: brandGreen, opacity: 0.45 }}
          aria-hidden="true"
        />

        <p
          className="text-[12.5px] sm:text-[13.5px] leading-relaxed"
          style={{ color: bodyText }}
        >
          {description}
        </p>
      </div>
    </div>
  );

  return (
    <section
      className="w-full py-14 md:py-20 overflow-hidden relative"
      style={{ backgroundColor: pageBg }}
    >
      {/* CSS */}
      <style>{`
        @keyframes nl-float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
        }

        @keyframes nl-pulse-ring {
          0% { transform: scale(0.9); opacity: 0.35; }
          70% { transform: scale(1.25); opacity: 0; }
          100% { transform: scale(1.25); opacity: 0; }
        }

        @keyframes nl-rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .nl-float-anim {
          animation: nl-float 2.5s ease-in-out infinite;
          will-change: transform;
          cursor: default !important;
          pointer-events: none;
        }

        .nl-pulse-ring {
          animation: nl-pulse-ring 1.8s ease-out infinite;
        }

        .nl-rotate-slow {
          animation: nl-rotate 15s linear infinite;
        }

        .nl-rotate-rev {
          animation: nl-rotate 20s linear infinite reverse;
        }

        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">

        {/* HEADING */}
        <div className="text-center mb-12 lg:mb-16">

          <p className="text-[#A4BE2C] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
            WHY CHOOSE NUTRALIKE
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-serif text-[#355931] leading-tight">
            Why <span className="gradient-text">Nutralike?</span>
          </h2>

          {/* Underline */}
          <div
            className="w-24 h-[2px] mx-auto mt-6 mb-6"
            style={{
              background:
                "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
            }}
          />

          <p className="max-w-2xl mx-auto text-sm sm:text-base leading-relaxed text-gray-600">
            Six principles that shape every formulation, every batch,
            and every partnership we build.
          </p>

        </div>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_260px_1fr] gap-6 lg:gap-10 items-center">

          {/* LEFT */}
          <div className="flex flex-col gap-5 lg:gap-6">
            {leftCards.map((c, i) => (
              <Card key={`l-${i}`} {...c} side="left" index={i + 1} />
            ))}
          </div>

          {/* CENTER */}
          <div className="flex justify-center items-center order-first lg:order-none">

            <div className="relative w-52 h-52 lg:w-64 lg:h-64 flex items-center justify-center">

              <span
                className="nl-rotate-slow absolute inset-0 rounded-full"
                style={{ border: "1px dashed rgba(53,89,49,0.55)" }}
              />

              <span
                className="nl-rotate-rev absolute inset-4 rounded-full"
                style={{ border: "1px dotted rgba(53,89,49,0.35)" }}
              />

              <span
                className="nl-pulse-ring absolute inset-6 rounded-full"
                style={{
                  background:
                    "radial-gradient(circle, rgba(53,89,49,0.18) 0%, rgba(53,89,49,0) 70%)",
                }}
              />

              <span
                className="absolute inset-8 rounded-full blur-xl opacity-60"
                style={{
                  background:
                    "radial-gradient(circle, rgba(53,89,49,0.20) 0%, rgba(53,89,49,0) 70%)",
                }}
              />

              <span
                className="absolute inset-6 rounded-full"
                style={{
                  backgroundColor: cardBg,
                  boxShadow:
                    "inset 0 0 0 1px rgba(53,89,49,0.25), 0 10px 30px rgba(53,89,49,0.08)",
                }}
              />

              <img
                src={bigLogoImg}
                alt="NUTRALIKE GROUP"
                className="nl-float-anim relative w-38 h-38 lg:w-46 lg:h-46 object-contain drop-shadow-[0_8px_16px_rgba(53,89,49,0.18)]"
              />
            </div>

          </div>

          {/* RIGHT */}
          <div className="flex flex-col gap-5 lg:gap-6">
            {rightCards.map((c, i) => (
              <Card key={`r-${i}`} {...c} side="right" index={i + 4} />
            ))}
          </div>

        </div>

        {/* FOOTER */}
        <div className="flex items-center justify-center gap-4 mt-14 lg:mt-16">
          <span
            className="h-px w-16"
            style={{ backgroundColor: borderTint }}
          />

          <span
            className="text-[10px] tracking-[0.5em] uppercase font-semibold"
            style={{ color: brandGreen }}
          >
            Est. 2014
          </span>

          <span
            className="h-px w-16"
            style={{ backgroundColor: borderTint }}
          />
        </div>

      </div>
    </section>
  );
};

export default Third_AboutUs_Section;